import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faPlus,
  faEdit,
  faTrash,
  faImage,
  faCheck,
  faTimes,
  faUpload,
  faEye,
  faDownload,
  faCalendar,
  faFileImage
} from '@fortawesome/free-solid-svg-icons';
import '../styles/AdminCovers.css';

const AdminCovers = () => {
  const [covers, setCovers] = useState([]);
  const [filteredCovers, setFilteredCovers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterType, setFilterType] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingCover, setEditingCover] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  // Mock covers data with real anime images from reliable CDN
  const mockCovers = [
    {
      id: 1,
      name: 'Attack on Titan Poster',
      filename: 'aot-poster.jpg',
      original_name: 'attack-on-titan-official.jpg',
      file_url: 'https://m.media-amazon.com/images/M/MV5BNzc5MTczNDQtNDFjNi00ZDU5LWFkNzItOTE1NzQzMzdhNzU5XkEyXkFqcGdeQXVyNjc2NjA5MTU@._V1_FMjpg_UX1000_.jpg',
      thumbnail_url: 'https://m.media-amazon.com/images/M/MV5BNzc5MTczNDQtNDFjNi00ZDU5LWFkNzItOTE1NzQzMzdhNzU5XkEyXkFqcGdeQXVyNjc2NjA5MTU@._V1_FMjpg_UX1000_.jpg',
      file_size: 1536000,
      file_type: 'image/jpeg',
      dimensions: '600x900',
      usage_count: 8,
      status: 'active',
      alt_text: 'Attack on Titan poster',
      description: 'Official poster for Attack on Titan final season',
      uploaded_by: 'Admin',
      created_at: '2024-01-10',
      updated_at: '2024-01-16'
    },
    {
      id: 2,
      name: 'Demon Slayer Banner',
      filename: 'demon-slayer-banner.png',
      original_name: 'kimetsu-hero-banner.png',
      file_url: 'https://m.media-amazon.com/images/M/MV5BZjZjNzI5MDctY2Y4YS00NmM4LTljMmItZTFkOTExNGI3ODRhXkEyXkFqcGdeQXVyNjc3MjQzNTI@._V1_FMjpg_UX1000_.jpg',
      thumbnail_url: 'https://m.media-amazon.com/images/M/MV5BZjZjNzI5MDctY2Y4YS00NmM4LTljMmItZTFkOTExNGI3ODRhXkEyXkFqcGdeQXVyNjc3MjQzNTI@._V1_FMjpg_UX1000_.jpg',
      file_size: 2048000,
      file_type: 'image/png',
      dimensions: '1920x1080',
      usage_count: 3,
      status: 'active',
      alt_text: 'Demon Slayer anime banner',
      description: 'Hero banner for Demon Slayer series homepage',
      uploaded_by: 'Editor',
      created_at: '2024-01-12',
      updated_at: '2024-01-18'
    },
    {
      id: 3,
      name: 'One Piece Cover',
      filename: 'one-piece-cover.jpg',
      original_name: 'one-piece-poster.jpg',
      file_url: 'https://m.media-amazon.com/images/M/MV5BODcwNWE3OTMtMDc3MS00NDFjLWE1OTAtNDU3NjgxODMxY2UyXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_FMjpg_UX1000_.jpg',
      thumbnail_url: 'https://m.media-amazon.com/images/M/MV5BODcwNWE3OTMtMDc3MS00NDFjLWE1OTAtNDU3NjgxODMxY2UyXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_FMjpg_UX1000_.jpg',
      file_size: 1024000,
      file_type: 'image/jpeg',
      dimensions: '800x1200',
      usage_count: 5,
      status: 'active',
      alt_text: 'One Piece anime poster',
      description: 'Official poster for One Piece anime series',
      uploaded_by: 'Admin',
      created_at: '2024-01-15',
      updated_at: '2024-01-20'
    },
    {
      id: 4,
      name: 'Jujutsu Kaisen Cover',
      filename: 'jjk-cover.jpg',
      original_name: 'jujutsu-kaisen-poster.jpg',
      file_url: 'https://m.media-amazon.com/images/M/MV5BNGY4MTg3NzgtMmFkZi00NTg5LWExMmEtMWI3YzI1ODdmMWQ5XkEyXkFqcGdeQXVyMjQwMDg0Ng@@._V1_FMjpg_UX1000_.jpg',
      thumbnail_url: 'https://m.media-amazon.com/images/M/MV5BNGY4MTg3NzgtMmFkZi00NTg5LWExMmEtMWI3YzI1ODdmMWQ5XkEyXkFqcGdeQXVyMjQwMDg0Ng@@._V1_FMjpg_UX1000_.jpg',
      file_size: 512000,
      file_type: 'image/jpeg',
      dimensions: '1920x1080',
      usage_count: 0,
      status: 'active',
      alt_text: 'Jujutsu Kaisen poster',
      description: 'Official poster for Jujutsu Kaisen anime',
      uploaded_by: 'Admin',
      created_at: '2024-01-08',
      updated_at: '2024-01-14'
    },
    {
      id: 5,
      name: 'My Hero Academia Poster',
      filename: 'mha-poster.jpg',
      original_name: 'boku-no-hero-academia.jpg',
      file_url: 'https://m.media-amazon.com/images/M/MV5BNTI3YzEyMTMtMWI0Ni00NGE4LWJhNzEtMmM4M2Q1NzA4MzJkXkEyXkFqcGdeQXVyMzgxODM4NjM@._V1_FMjpg_UX1000_.jpg',
      thumbnail_url: 'https://m.media-amazon.com/images/M/MV5BNTI3YzEyMTMtMWI0Ni00NGE4LWJhNzEtMmM4M2Q1NzA4MzJkXkEyXkFqcGdeQXVyMzgxODM4NjM@._V1_FMjpg_UX1000_.jpg',
      file_size: 1800000,
      file_type: 'image/jpeg',
      dimensions: '900x1350',
      usage_count: 12,
      status: 'active',
      alt_text: 'My Hero Academia poster',
      description: 'Boku no Hero Academia official artwork',
      uploaded_by: 'Admin',
      created_at: '2024-01-05',
      updated_at: '2024-01-19'
    },
    {
      id: 6,
      name: 'Naruto Poster',
      filename: 'naruto-poster.jpg',
      original_name: 'naruto-shippuden.jpg',
      file_url: 'https://m.media-amazon.com/images/M/MV5BZmQ5NGFiNWEtMmMyMC00MDdiLWI4VWQtZTg0YWQ3MTI3Y2VjXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_FMjpg_UX1000_.jpg',
      thumbnail_url: 'https://m.media-amazon.com/images/M/MV5BZmQ5NGFiNWEtMmMyMC00MDdiLWI4VWQtZTg0YWQ3MTI3Y2VjXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_FMjpg_UX1000_.jpg',
      file_size: 2200000,
      file_type: 'image/jpeg',
      dimensions: '1920x1080',
      usage_count: 7,
      status: 'active',
      alt_text: 'Naruto anime poster',
      description: 'Naruto Shippuden season banner',
      uploaded_by: 'Editor',
      created_at: '2024-01-07',
      updated_at: '2024-01-17'
    }
  ];

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      setCovers(mockCovers);
      setFilteredCovers(mockCovers);
      setLoading(false);
    }, 1000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    filterAndSortCovers();
  }, [searchTerm, sortField, sortDirection, filterType, covers]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterAndSortCovers = () => {
    let filtered = [...covers];

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(cover =>
        cover.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cover.filename.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cover.alt_text.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by type
    if (filterType !== 'all') {
      if (filterType === 'images') {
        filtered = filtered.filter(cover => cover.file_type.startsWith('image/'));
      } else if (filterType === 'used') {
        filtered = filtered.filter(cover => cover.usage_count > 0);
      } else if (filterType === 'unused') {
        filtered = filtered.filter(cover => cover.usage_count === 0);
      } else if (filterType === 'active') {
        filtered = filtered.filter(cover => cover.status === 'active');
      } else if (filterType === 'inactive') {
        filtered = filtered.filter(cover => cover.status === 'inactive');
      }
    }

    // Sort
    filtered.sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (sortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    setFilteredCovers(filtered);
  };

  // eslint-disable-next-line no-unused-vars
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const handleAddCover = () => {
    setEditingCover(null);
    setShowAddModal(true);
  };

  const handleEditCover = (cover) => {
    setEditingCover(cover);
    setShowAddModal(true);
  };

  const handleDeleteCover = (coverId) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa ảnh này?')) {
      setCovers(covers.filter(cover => cover.id !== coverId));
    }
  };

  const handleToggleStatus = (coverId) => {
    setCovers(covers.map(cover => {
      if (cover.id === coverId) {
        return {
          ...cover,
          status: cover.status === 'active' ? 'inactive' : 'active'
        };
      }
      return cover;
    }));
  };

  const handlePreviewImage = (cover) => {
    setPreviewImage(cover);
  };

  const handleSaveCover = (coverData) => {
    if (editingCover) {
      // Update existing cover
      setCovers(covers.map(cover => 
        cover.id === editingCover.id 
          ? { ...cover, ...coverData, updated_at: new Date().toISOString().split('T')[0] }
          : cover
      ));
    } else {
      // Add new cover
      const newCover = {
        id: Date.now(),
        ...coverData,
        usage_count: 0,
        uploaded_by: 'Admin',
        created_at: new Date().toISOString().split('T')[0],
        updated_at: new Date().toISOString().split('T')[0]
      };
      setCovers([...covers, newCover]);
    }
    setShowAddModal(false);
    setEditingCover(null);
  };

  const handleCancelEdit = () => {
    setShowAddModal(false);
    setEditingCover(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'success';
      case 'inactive': return 'warning';
      default: return 'secondary';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active': return 'Hoạt động';
      case 'inactive': return 'Tạm dừng';
      default: return 'Không xác định';
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('vi-VN');
  };

  const getFileTypeIcon = (fileType) => {
    if (fileType.startsWith('image/')) {
      return faFileImage;
    }
    return faFileImage;
  };

  if (loading) {
    return (
      <div className="admin-covers">
        <div className="covers-loading">
          <div className="loading-spinner"></div>
          <p>Đang tải danh sách ảnh bìa...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-covers">
      <div className="covers-header">
        <div className="header-left">
          <h1>
            <FontAwesomeIcon icon={faImage} />
            Quản lý Ảnh bìa
          </h1>
          <p>Quản lý các ảnh bìa, poster và hình ảnh trong hệ thống</p>
        </div>
        <div className="header-actions">
          <button className="add-cover-btn" onClick={handleAddCover}>
            <FontAwesomeIcon icon={faPlus} />
            Thêm ảnh mới
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="cover-stats">
        <div className="stat-card">
          <div className="stat-icon success">
            <FontAwesomeIcon icon={faImage} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{covers.filter(c => c.status === 'active').length}</div>
            <div className="stat-label">Ảnh hoạt động</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon warning">
            <FontAwesomeIcon icon={faTimes} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{covers.filter(c => c.usage_count === 0).length}</div>
            <div className="stat-label">Ảnh chưa sử dụng</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon primary">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{covers.reduce((sum, c) => sum + c.usage_count, 0)}</div>
            <div className="stat-label">Lượt sử dụng</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon info">
            <FontAwesomeIcon icon={faFileImage} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{(covers.reduce((sum, c) => sum + c.file_size, 0) / 1024 / 1024).toFixed(1)}MB</div>
            <div className="stat-label">Tổng dung lượng</div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="covers-filters">
        <div className="search-box">
          <FontAwesomeIcon icon={faSearch} />
          <input
            type="text"
            placeholder="Tìm kiếm ảnh..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="filter-select">
          <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
            <option value="all">Tất cả</option>
            <option value="images">Chỉ ảnh</option>
            <option value="used">Đã sử dụng</option>
            <option value="unused">Chưa sử dụng</option>
            <option value="active">Hoạt động</option>
            <option value="inactive">Tạm dừng</option>
          </select>
        </div>
      </div>

      {/* Covers Grid */}
      <div className="covers-grid-container">
        <div className="covers-grid">
          {filteredCovers.map(cover => (
            <div key={cover.id} className="cover-card">
              <div className="cover-image">
                <img 
                  src={cover.thumbnail_url} 
                  alt={cover.alt_text}
                  onError={(e) => {
                    e.target.src = '/logo.png';
                  }}
                />
                <div className="cover-overlay">
                  <button 
                    className="overlay-btn view"
                    title="Xem ảnh"
                    onClick={() => handlePreviewImage(cover)}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                  <a 
                    href={cover.file_url} 
                    download={cover.filename}
                    className="overlay-btn download"
                    title="Tải xuống"
                  >
                    <FontAwesomeIcon icon={faDownload} />
                  </a>
                  <button 
                    className="overlay-btn edit"
                    title="Chỉnh sửa"
                    onClick={() => handleEditCover(cover)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button 
                    className="overlay-btn delete"
                    title="Xóa"
                    onClick={() => handleDeleteCover(cover.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </div>
              <div className="cover-info">
                <div className="cover-header">
                  <h3 className="cover-name">{cover.name}</h3>
                  <div className={`status-badge ${getStatusColor(cover.status)}`}>
                    {getStatusText(cover.status)}
                  </div>
                </div>
                <div className="cover-details">
                  <div className="detail-item">
                    <FontAwesomeIcon icon={getFileTypeIcon(cover.file_type)} />
                    <span>{cover.dimensions}</span>
                  </div>
                  <div className="detail-item">
                    <FontAwesomeIcon icon={faFileImage} />
                    <span>{formatFileSize(cover.file_size)}</span>
                  </div>
                  <div className="detail-item">
                    <FontAwesomeIcon icon={faEye} />
                    <span>{cover.usage_count} lần</span>
                  </div>
                  <div className="detail-item">
                    <FontAwesomeIcon icon={faCalendar} />
                    <span>{formatDate(cover.created_at)}</span>
                  </div>
                </div>
                <div className="cover-actions">
                  <button 
                    className={`action-btn toggle ${cover.status}`}
                    title={cover.status === 'active' ? 'Tạm dừng' : 'Kích hoạt'}
                    onClick={() => handleToggleStatus(cover.id)}
                  >
                    <FontAwesomeIcon icon={cover.status === 'active' ? faTimes : faCheck} />
                    {cover.status === 'active' ? 'Tạm dừng' : 'Kích hoạt'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Cover Form Modal */}
      {showAddModal && (
        <CoverForm
          cover={editingCover}
          onSave={handleSaveCover}
          onCancel={handleCancelEdit}
          isOpen={showAddModal}
        />
      )}

      {/* Image Preview Modal */}
      {previewImage && (
        <ImagePreview
          cover={previewImage}
          onClose={() => setPreviewImage(null)}
        />
      )}
    </div>
  );
};

// Cover Form Component
const CoverForm = ({ cover, onSave, onCancel, isOpen }) => {
  const [formData, setFormData] = useState({
    name: '',
    filename: '',
    file_url: '',
    alt_text: '',
    description: '',
    status: 'active'
  });

  useEffect(() => {
    if (cover) {
      setFormData({
        name: cover.name || '',
        filename: cover.filename || '',
        file_url: cover.file_url || '',
        alt_text: cover.alt_text || '',
        description: cover.description || '',
        status: cover.status || 'active'
      });
    } else {
      setFormData({
        name: '',
        filename: '',
        file_url: '',
        alt_text: '',
        description: '',
        status: 'active'
      });
    }
  }, [cover]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Mock file processing - in real app would handle file upload
    const mockData = {
      ...formData,
      original_name: formData.filename,
      thumbnail_url: `/covers/thumbs/${formData.filename}`,
      file_size: Math.floor(Math.random() * 2000000) + 500000, // Random size
      file_type: 'image/jpeg',
      dimensions: '800x1200'
    };
    
    onSave(mockData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content cover-form-modal">
        <div className="modal-header">
          <h3>
            <FontAwesomeIcon icon={faImage} />
            {cover ? 'Chỉnh sửa ảnh' : 'Thêm ảnh mới'}
          </h3>
          <button className="modal-close" onClick={onCancel}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="cover-form">
          <div className="form-grid">
            <div className="form-group">
              <label>Tên ảnh *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="VD: One Piece Cover"
                required
              />
            </div>

            <div className="form-group">
              <label>Tên file *</label>
              <input
                type="text"
                name="filename"
                value={formData.filename}
                onChange={handleChange}
                placeholder="one-piece-cover.jpg"
                required
              />
            </div>

            <div className="form-group full-width">
              <label>URL ảnh *</label>
              <input
                type="url"
                name="file_url"
                value={formData.file_url}
                onChange={handleChange}
                placeholder="/covers/one-piece-cover.jpg"
                required
              />
            </div>

            <div className="form-group full-width">
              <label>Alt text</label>
              <input
                type="text"
                name="alt_text"
                value={formData.alt_text}
                onChange={handleChange}
                placeholder="Mô tả ngắn cho SEO và accessibility"
              />
            </div>

            <div className="form-group full-width">
              <label>Mô tả</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Mô tả chi tiết về ảnh..."
                rows={3}
              />
            </div>

            <div className="form-group">
              <label>Trạng thái</label>
              <select name="status" value={formData.status} onChange={handleChange}>
                <option value="active">Hoạt động</option>
                <option value="inactive">Tạm dừng</option>
              </select>
            </div>
          </div>

          <div className="upload-section">
            <div className="upload-area">
              <FontAwesomeIcon icon={faUpload} />
              <p>Kéo thả file ảnh vào đây hoặc click để chọn</p>
              <input type="file" accept="image/*" style={{ display: 'none' }} />
              <button type="button" className="btn-upload">
                <FontAwesomeIcon icon={faUpload} />
                Chọn file
              </button>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={onCancel}>
              <FontAwesomeIcon icon={faTimes} />
              Hủy
            </button>
            <button type="submit" className="btn-save">
              <FontAwesomeIcon icon={faCheck} />
              {cover ? 'Cập nhật' : 'Thêm mới'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Image Preview Component
const ImagePreview = ({ cover, onClose }) => {
  return (
    <div className="modal-overlay image-preview-overlay" onClick={onClose}>
      <div className="image-preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="preview-header">
          <h3>{cover.name}</h3>
          <button className="modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="preview-content">
          <img src={cover.file_url} alt={cover.alt_text} />
          <div className="preview-info">
            <div className="info-item">
              <strong>Kích thước:</strong> {cover.dimensions}
            </div>
            <div className="info-item">
              <strong>Dung lượng:</strong> {(cover.file_size / 1024 / 1024).toFixed(2)} MB
            </div>
            <div className="info-item">
              <strong>Loại file:</strong> {cover.file_type}
            </div>
            <div className="info-item">
              <strong>Đã sử dụng:</strong> {cover.usage_count} lần
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCovers;